var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0C0.358172 0 0 0.358172 0 0.8C0 1.24183 0.358172 1.6 0.8 1.6H9.6C10.0418 1.6 10.4 1.24183 10.4 0.8C10.4 0.358172 10.0418 0 9.6 0H0.8Z",
    fill: "#767681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 3.2C0.358172 3.2 0 3.55817 0 4C0 4.44183 0.358172 4.8 0.8 4.8H4.8C5.24183 4.8 5.6 4.44183 5.6 4C5.6 3.55817 5.24183 3.2 4.8 3.2H0.8Z",
    fill: "#767681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 6.4C0.358172 6.4 0 6.75817 0 7.2C0 7.64183 0.358172 8 0.8 8H4C4.44183 8 4.8 7.64183 4.8 7.2C4.8 6.75817 4.44183 6.4 4 6.4H0.8Z",
    fill: "#767681"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 10.4C8.8 10.8418 9.15817 11.2 9.6 11.2C10.0418 11.2 10.4 10.8418 10.4 10.4L10.4 5.93137L11.4343 6.96569C11.7467 7.27811 12.2533 7.27811 12.5657 6.96569C12.8781 6.65327 12.8781 6.14674 12.5657 5.83432L10.1657 3.43431C10.0157 3.28429 9.81218 3.2 9.6 3.2C9.38783 3.2 9.18435 3.28429 9.03432 3.43431L6.63432 5.83431C6.3219 6.14673 6.3219 6.65327 6.63432 6.96569C6.94674 7.27811 7.45327 7.27811 7.76569 6.96569L8.8 5.93137V10.4Z",
    fill: "#767681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.78fe415f7a13b9a84a053e27663e2b15.svg";
export { ForwardRef as ReactComponent };